export enum GraphColorStyleEnum {
  greenUpRedDown = 0, // default
  greenUpBlackDown = 1,
  redUpBlackDown = 2,
}

export enum NOPColorStyleEnum {
  blue = '#6495ed80',
  navy = '#000080',
  green = '#228B2280',
  lime = '#00FF00',
}

export enum ConcentrationColorStyleEnum {
  green = '#228B2280',
  lime = '#00FF00',
  lightBlue = '#6495ed80',
  orange = '#FFA500',
}

export enum ComparisonColorStyleEnum {
  orange = 'orange',
  yellow = '#e8cc28',
}

export enum FreeUserAlertEnum {
  showParticipantNumberChangeFilterAlert = 'showParticipantNumberChangeFilterAlert',
  showPriceRangeFilterAlert = 'showPriceRangeFilterAlert',
}

// A reference to the Boostrap 5 breakpoints
// https://getbootstrap.com/docs/5.0/layout/containers/
export enum Breakpoints {
  small = 576,
  medium = 768,
  large = 992,
  extraLarge = 1200,
  extraExtraLarge = 1400,
  extraExtraExtraLarge = 2560,
}

export enum PriceGroupColorEnum {
  group0 = 'rgba(152,115,172)',
  group1 = 'rgba(130,163,255)',
  group2 = 'rgba(227,28,121)',
  group3 = 'rgba(185,71,0)',
}

export enum RetailInstitutionalTradesEnum {
  retailTrades = 'retail-trades',
  institutionalTrades = 'institutional-trades',
}

export enum MarkAreaColor {
  sell = 'rgb(255, 243, 242)',
  buy = 'rgb(242, 253, 244)',
  longPosition = 'rgb(255, 253, 235)',
}

export enum MarkAreaHoverColor {
  sell = 'rgb(255, 201, 196)',
  buy = 'rgb(207, 252, 215)',
  longPosition = 'rgb(252, 246, 187)',
}

export enum StrategyModeEnum {
  simpleMode = 'simple-mode',
  backtestMode = 'backtest-mode',
}
